<template>
  <div class="hello">
    <div style="height: 54px;"></div>
    <div class="head">
      <div>
        <router-link to="/">
          <img class="logo" src="../../assets/newLogo-white.png" alt=""
        /></router-link>
        <ul class="nav_left">
          <li @click="pushHome" :style="{ marginLeft: '81px' }">
            <span>首页</span>
          </li>
          <!-- 云服务 -->
          <li
            :style="{
              marginLeft: '60px',
            }"
            @mouseenter="service = true"
            @mouseleave="service = false"
          >
            <span>云服务</span></span
            ><img class="img1" src="../../assets/images/bottom.png" alt="" />
            <img
              class="img2"
              style="display: none;"
              src="../../assets/images/shang.png"
              alt=""
            />
            <transition name="el-fade-in-linear">
              <ul v-show="service">
                <a @click="push_eval_jees" href="javascript:;"> 账户列表</a>
                <!-- <a @click="push_account_contrast" href="javascript:;"
                  >多账户拟合分析</a
                > -->
                <a @click="push_grouping" href="javascript:;"> 分组管理</a>
                <a
                  style="border-bottom: 0;"
                  @click="push_ctp_user"
                  href="javascript:;"
                  >外部数据导入分析</a
                >
              </ul>
            </transition>
          </li>

          <li
            @click="push_authentication"
            style="margin-left: 58px;display: flex;"
          >
            <span>机构版</span>
            <!-- <i
            style="color: #fff;margin-top: 7px;margin-left: 3px;font-size: 12px;background-color:#ff3737;height: 20px;border-radius: 8px 8px 8px 0;z-index: 10;display: block;line-height: 20px;text-align: center;width: 45px;padding-right: 1px;"
            >公测版</i
          > -->
          </li>

          <!-- 模拟测试 -->
          <li
            :style="{
              marginLeft: '60px',
            }"
            @mouseenter="test = true"
            @mouseleave="test = false"
          >
            <span>模拟测试</span
            ><img class="img1" src="../../assets/images/bottom.png" alt="" />
            <img
              class="img2"
              style="display: none;"
              src="../../assets/images/shang.png"
              alt=""
            />
            <transition name="el-fade-in-linear">
              <ul v-show="test">
                <a @click="push_simulation" href="javascript:;">
                  模拟账户申请</a
                >
                <a
                  style="border-bottom: 0;"
                  @click="push_download"
                  href="javascript:;"
                  >测试下载</a
                >
              </ul>
            </transition>
          </li>

          <li
            :style="{
              marginLeft: '60px',
            }"
            class="help"
            @mouseenter="help = true"
            @mouseleave="help = false"
          >
            <span>帮助</span
            ><img class="img1" src="../../assets/images/bottom.png" alt="" />
            <img
              class="img2"
              style="display: none;"
              src="../../assets/images/shang.png"
              alt=""
            />
            <transition name="el-fade-in-linear">
              <ul class="ul" v-show="help">
                <a href="javascript:;" @click="push_help">交易端手册</a>
                <a href="javascript:;" @click="push_helpl">多账户交易端手册</a>
                <a style="border-bottom: 0;" @click="push_feedback">意见反馈</a>
              </ul>
            </transition>
          </li>
          <!-- 帮助 -->
          <li
            :style="{
              marginLeft: '60px',
            }"
            class="help"
            @mouseenter="download = true"
            @mouseleave="download = false"
          >
            <span>终端下载</span
            ><img class="img1" src="../../assets/images/bottom.png" alt="" />
            <img
              class="img2"
              style="display: none;"
              src="../../assets/images/shang.png"
              alt=""
            />
            <transition name="el-fade-in-linear">
              <ul class="ul" v-show="download">
                <a href="javascript:;" @click="push_Tdownload1">杰宜斯云极速版</a>
                <a href="javascript:;" @click="push_TdownloadRisk">杰宜斯云风控</a>
                <a href="javascript:;" @click="push_Tdownload2">多账户交易终端</a>
              </ul>
            </transition>
          </li>
        </ul>
        <ul class="nav_right">
          <!-- <li class="help" @mouseenter='help=true' @mouseleave='help=false'>帮助
                <transition name="el-fade-in-linear">
                <ul class="ul"  v-show=help>
                  <a href="javascript:;" @click = push_help>交易端手册</a>
                  <a href="javascript:;" @click = push_helpl>多账户交易端手册</a>
                  <a @click = push_feedback>意见反馈</a>
                </ul>
              </transition>
               </li> -->
          <li @click="push_eval_jeesConsole" style="display: flex;" v-if="false">
            <i style="font-size: 19px;" class="iconfont icon-normal"></i>
            <span>&nbsp;控制台</span>
          </li>
          <!-- <li @click="push_Tdownload" style="display: flex;">
            <i style="font-size: 18px;" class="iconfont icon-zhongduan"></i>
            <span>&nbsp;终端下载</span>
          </li> -->
          <div
            class="login"
            style="margin-left: 60px;font-size: 16px;line-height: 60px;cursor: pointer;"
            v-if="userstate"
            @click="login"
          >
            登录/注册
          </div>
          <!-- <li v-if=userstate @click=register>注册</li> -->
          <li
            class="li_img liImg"
            v-if="!userstate"
            @mouseenter="user = true"
            @mouseleave="user = false"
            :style="{
              width: '60px',
              height: '52px',
              marginLeft: '35px',
              marginRight: '70px',
            }"
          >
            <img
              src="../../assets/images/headPic.png"
              alt=""
              style="width: 36px;height: 36px;margin: 9px auto 0;display: block;"
            />
            <transition name="el-fade-in-linear">
              <ul class="user" v-show="user">
                <a
                  style="border-bottom: 1px solid #EDF0F6;"
                  @click="push_account"
                  href="javascript:;"
                >
                  个人中心</a
                >
                <a @click="next">退出登录</a>
              </ul>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import './style.css';
import '@/assets/iconfont/iconfont.css';
export default {
  name: 'hhead',
  data() {
    return {
      service: false,
      help: false,
      user: false,
      test: false,
      download:false,
      userstate: localStorage.getItem('token') ? false : true,
      border: '2px solid #5B85FF',
      color_: '#5B85FF',
      border1: '2px solid #5B85FF',
      color_1: '#5B85FF',
      border2: '2px solid #5B85FF',
      color_2: '#5B85FF',
      border3: '2px solid #5B85FF',
      color_3: '#5B85FF',
    };
  },
  created() {},
  mounted() {
    // console.log(this.$route.path);
    // console.log(this.$route);
  },

  methods: {
    toCurrentPage: function(thisId) {
      this.$router.push({ path: '/test ', query: { id: thisId, option: '' } });
    },
    push_eval_jeesConsole() {
      this.$router.push('/user/eval_jees/list?type=console');
    },
    push_eval_jees() {
      this.$router.push('/user/eval_jees/list');
    },
    push_grouping() {
      this.$router.push('/user/grouping/list');
    },
    push_account_contrast() {
      this.$router.push('/user/account_contrast/list');
    },
    push_ctp_user() {
      this.$router.push('/user/ctp_user/list');
    },
    push_simulation() {
      this.$router.push('/user/sim_user/list');
    },
    push_download() {
      this.$router.push('/user/sim_user/download');
    },
    push_Tdownload() {
      //终端下载
      this.$router.push('/index/download');
    },

    next() {
      localStorage.removeItem('token');
      localStorage.removeItem('res');
      //   localStorage.removeItem('msg');
      window.location.href = '/';
    },
    push_account() {
      this.$router.push('/user/account/list');
    },
    register() {
      this.$router.push('/login?type=register');
    },
    login() {
      localStorage.setItem(
        'path',
        `${this.$route.path}${
          this.$route.query.type ? '?type=' + this.$route.query.type : ''
        }`
      );
      this.$router.push('/login?type=login');
    },
    push_feedback() {
      this.$router.push('/index/feedback/put');
    },
    push_help() {
      window.location.href = '/index/help/faq?type=4';
    },
    push_Tdownload1(){
      this.$router.push('/index/download1');
    },
    push_Tdownload2(){
      this.$router.push('/index/download2');
    },
    push_TdownloadRisk(){
      this.$router.push('/index/downloadRisk');
    },
    push_helpl() {
      window.location.href = '/index/help/faq?type=5';
    },
    pushHome() {
      this.$router.push('/');
    },
    push_authentication() {
      //crm
      window.open('_blank').location.href = '/crm/index';
    },
  },
  watch: {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/header/index.vue